var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"auto-container pa-0"},[_c('v-col',{staticClass:"pa-0 ma-0"},[_c('v-checkbox',{staticClass:"pa-0 pl-4",attrs:{"label":_vm.title},on:{"change":_vm.onChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }